export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const tooltipIcons = document.querySelectorAll('.text-tooltip__icon');
        const tooltipContents = document.querySelectorAll('.text-tooltip__content.custom');

        tooltipIcons.forEach((tooltipIcon, index) => {
            const tooltipContent = tooltipContents[index];

            if (!tooltipContent) return;

            tooltipIcon.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                tooltipContents.forEach((content, i) => {
                    if (i !== index) {
                        content.classList.remove('active');
                    }
                });

                tooltipContent.classList.toggle('active');
            });
        });

        document.addEventListener('click', (event) => {
            tooltipContents.forEach((tooltipContent) => {
                const isClickInsideTooltip = tooltipContent.contains(event.target);

                if (!isClickInsideTooltip) {
                    tooltipContent.classList.remove('active');
                }
            });
        });
    });
}


